export const useExportEmails = (domainValue: string) => {
  const exportEmails = (emailIds: number[]) => {
    const formData = new FormData()
    formData.append("email_ids", emailIds.join(","))

    fetch(`/search/${domainValue}/download`, {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
          ?.content,
      },
    })
      .then((response) => {
        const contentType = response.headers.get("content-type")

        if (contentType && contentType.includes("application/json")) {
          // Handle JSON response
          return response.json().then((data) => {
            if (data.message) {
              App.displayFlash("success", data.message)
            }
          })
        } else if (contentType && contentType.includes("text/csv")) {
          // Handle CSV file download
          return response.blob().then((blob) => {
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement("a")
            a.href = url
            a.download = `export-${domainValue}.csv`
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          })
        }
      })
      .catch(() => {
        App.displayFlash(
          "danger",
          i18n.t("js.front.api_errors.internal_server_error"),
        )
      })
  }

  return exportEmails
}
